export default __webpack_public_path__ + "static/media/CONDOR_Manualidad.14d3294d.jpeg";